// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OrgMng_wrapper__l-DqB"};